import React, { type PropsWithChildren } from 'react';
import { useUserData } from '@hooks/useUserData';
import { useAutoTest } from '@hooks/useAutoTest';

// Bootstraps authorization by enabling the userData query (the single source of
// truth for user data). Never suspends: the readers wait on `isInitialUserDataUpdated`.
const AuthGate = (props: PropsWithChildren) => {
  const { children } = props;

  useUserData({ enabled: true });
  useAutoTest();

  return children as React.ReactElement;
};

export default AuthGate;
